
document.addEventListener('DOMContentLoaded', () => {
      const swiperNewbanner = new Swiper('.newBanner__swiper', {
      spaceBetween: 16, 
      pagination: {
      el: '.swiper-pagination',
      clickable: true,
      },
      navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      },
  });   
  


  
 swiperProduct = new Swiper('.customProduct__swiper', {   
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
       
    
 const swiperTestimonial = new Swiper('.testimonials-swiper', {
      slidesPerView: 1,
      spaceBetween: 16,
      centerSlides: true,
      pagination: {
      el: '.swiper-pagination',
      clickable: true,
      },
      navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      }
   });

 const swiperShopcollection = new Swiper('.shopCollection__swiper', {
      slidesPerView: 1.3,
      spaceBetween: 15,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
      },
    });

const swiperMultipleCollection = new Swiper('.multipleCollections__swiper', {   
    spaceBetween: 15,
    slidesPerGroup: 1,

    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
              0: {
            slidesPerView: 2,
            slidesPerGroup: 2,
        },
       
        750: {
            slidesPerView: 4,
            slidesPerGroup: 4,
        },
       
        990: {
            slidesPerView: 6,
            slidesPerGroup: 6,
        },
    },
});

});



document.addEventListener('DOMContentLoaded', () => {    
  let swiperYouMayAlso = null;
  let swiperDealCollection = null;
  let swiperFeaturedCollection = null;
  let swiperFeaturedBlog = null;

  function initSwiper(selector, options) {
    return new Swiper(selector, options);
  }

  function initswiperYouMayAlso() {
    swiperYouMayAlso = initSwiper('.YouMayLike-container', {   
      slidesPerView: 1.3,
      spaceBetween: 15,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
      },
    });
  }

  function initSwiperDealCollection() {
    swiperDealCollection = initSwiper('.dealCollection__swiper', {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 32,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.3,
          slidesPerGroup: 1,
          spaceBetween: 15,
        },
        750: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
      },
    });
  }

  function initSwiperFeaturedCollection() {
    swiperFeaturedCollection = initSwiper('.featureCollectionMobile', {
      slidesPerView: 1.3,
      spaceBetween: 15,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
      },
    });
  }

  function initSwiperFeaturedBlog() {
    swiperFeaturedBlog = initSwiper('.featuredBlog_swiper-container', {
      slidesPerView: 1.3,
      spaceBetween: 15,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
      },
    });
  }

  function handleResize() {
    const windowWidth = window.innerWidth;

    // swiperYouMayAlso
    if (windowWidth < 750) {
      if (!swiperYouMayAlso) {
        initswiperYouMayAlso();
      }
    } else {
      if (swiperYouMayAlso) {
        swiperYouMayAlso.destroy();
        swiperYouMayAlso = null;
      }
    }

    // Deal Collection Swiper
    if (windowWidth < 750 && !swiperDealCollection) {
      initSwiperDealCollection();
    } else if (windowWidth >= 750 && swiperDealCollection) {
      swiperDealCollection.destroy();
      swiperDealCollection = null;
    }

    // Featured Collection Swiper
    if (windowWidth < 750 && !swiperFeaturedCollection) {
      initSwiperFeaturedCollection();
    } else if (windowWidth >= 750 && swiperFeaturedCollection) {
      swiperFeaturedCollection.destroy();
      swiperFeaturedCollection = null;
    }

    // Featured Blog Swiper
    if (windowWidth < 750 && !swiperFeaturedBlog) {
      initSwiperFeaturedBlog();
    } else if (windowWidth >= 750 && swiperFeaturedBlog) {
      swiperFeaturedBlog.destroy();
      swiperFeaturedBlog = null;
    }
  }

  handleResize();
  window.addEventListener('resize', handleResize);
});

      
document.addEventListener('DOMContentLoaded', function() { 
    document.querySelectorAll('.ChildLinkDropdown').forEach(function(clickButton) {            
              clickButton.addEventListener('click', function(event) {
            event.preventDefault();
            this.classList.toggle('LinkActive'); 

            var childLink = this.nextElementSibling; 
            if (childLink && childLink.classList.contains('customchildLink')) {
                childLink.style.display = childLink.style.display === 'block' ? 'none' : 'block';
            }
        });
    });
});   

document.addEventListener('DOMContentLoaded', function() {
    const faqTitles = document.querySelectorAll('.FAqTitle_Title-main');
    faqTitles.forEach(title => {
        title.addEventListener('click', function() {
            const currentDescription = this.nextElementSibling;
            document.querySelectorAll('.FaqSectionDescription_Outer').forEach(desc => {
                if (desc !== currentDescription) {
                    desc.classList.remove('active');
                    desc.previousElementSibling.querySelector('.plus-icon').style.display = 'block';
                    desc.previousElementSibling.querySelector('.minus-icon').style.display = 'none';
                }
            });
            currentDescription.classList.toggle('active');
            const plusIcon = this.querySelector('.plus-icon');
            const minusIcon = this.querySelector('.minus-icon');
            if (currentDescription.classList.contains('active')) {
                plusIcon.style.display = 'none';
                minusIcon.style.display = 'block';
            } else {
                plusIcon.style.display = 'block';
                minusIcon.style.display = 'none';
            }
        });
    });
});


 document.querySelectorAll('.TabsLink').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
           document.querySelectorAll('.TabsLink').forEach(tab => {
        tab.parentNode.classList.remove('active');
      });
           this.parentNode.classList.add('active');
      const targetId = this.getAttribute('href');

      document.querySelectorAll('.TabsContentBox').forEach(section => {
        if (section.id === targetId.substring(1)) {
          section.classList.add('active');
          section.querySelector('.descriptionDeatailsbox').style.display = 'block';
        } else {
          section.classList.remove('active');
          section.querySelector('.descriptionDeatailsbox').style.display = 'none';
        }
      });
      // document.querySelector(targetId).scrollIntoView({ behavior: 'smooth' });
    });
  });

  document.querySelectorAll('.descriptionDeatailsboxs').forEach(header => {
    header.addEventListener('click', function(e) {
      e.preventDefault();
      const siblingDescription = this.nextElementSibling;
      if (siblingDescription.style.display === 'none' || !siblingDescription.style.display) {
        siblingDescription.style.display = 'block';
        this.parentNode.classList.add('active');
      } else {
        siblingDescription.style.display = 'none';
        this.parentNode.classList.remove('active');
      }
    });
  });







